"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.Wrapper = (0, styles_1.styled)(material_1.Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    userSelect: "none",
    width: "100%",
    height: "100%",
    overflowY: "auto",
    padding: theme.spacing(0.75),
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.spacing(0.5),
}));
//# sourceMappingURL=styled.js.map